import { loader } from 'graphql.macro';
import moment from 'moment';

import { appClient } from 'src/config/apollo';
import { toastNotificationsService } from 'src/config/rootService';
import { CoachingVisitNode } from 'src/generated/webapp_gql';
import { SessionUtilizationInfo } from 'src/modules/videoSessions/models/videoSessions';
import { FetchStatus } from 'src/shared/models/shared';

const GET_COACHING_SESSIONS_QUERY = loader('../documents/getCoachingSessions.graphql');

export interface VideoSessionsState {
    fetchStatus: FetchStatus;
    sessions: CoachingVisitNode[];
    sessionUtilizationInfo: SessionUtilizationInfo;
}

const defaultState: VideoSessionsState = {
    fetchStatus: FetchStatus.NotStarted,
    sessions: [],
    sessionUtilizationInfo: {
        coachingVisitsRemaining: 0,
        therapyVisitsRemaining: 0,
        resetDate: moment().add('1 year').startOf('year'),
        coveredTherapyVisits: 0,
        coveredCoachingVisits: 0,
    },
};

export const videoSessions = {
    state: defaultState,
    reducers: {
        addSessions: (
            state: VideoSessionsState,
            payload: CoachingVisitNode[] = [],
        ): VideoSessionsState => {
            return {
                ...state,
                sessions: payload,
            };
        },
        addSessionUtilizationInfo: (
            state: VideoSessionsState,
            payload: SessionUtilizationInfo,
        ): VideoSessionsState => {
            return {
                ...state,
                sessionUtilizationInfo: payload,
            };
        },
        fetchingStarted: (state: VideoSessionsState): VideoSessionsState => {
            return {
                ...state,
                fetchStatus: FetchStatus.InProgress,
            };
        },
        fetchingCompleted: (state: VideoSessionsState): VideoSessionsState => {
            return {
                ...state,
                fetchStatus: FetchStatus.Completed,
            };
        },
        fetchingFailed: (state: VideoSessionsState): VideoSessionsState => {
            return {
                ...state,
                fetchStatus: FetchStatus.Failed,
            };
        },
        'authentication/logout': () => {
            return defaultState;
        },
    },
    effects: dispatch => ({
        async fetchSessions(): Promise<void> {
            dispatch.videoSessions.fetchingStarted();
            appClient
                .query({
                    query: GET_COACHING_SESSIONS_QUERY,
                    fetchPolicy: 'network-only',
                })
                .then(result => {
                    dispatch.videoSessions.addSessions(result.data.coachingVisits);
                    dispatch.videoSessions.fetchingCompleted();
                })
                .catch(() => {
                    dispatch.videoSessions.fetchingFailed();
                    toastNotificationsService.renderErrorToast(
                        'Could not fetch coaching sessions.',
                    );
                });
        },
    }),
};
